import { css } from '@emotion/react';

import { Ref, forwardRef } from 'react';

import { Spacing } from 'chatie-design-system';

import { safeArea } from '../../styles/css';

type Props = {
  top?: boolean;
  bottom?: boolean;
  size: number;
};

const pushCSS = (isTopSafeArea: boolean, isBottomSafeArea: boolean) => css`
  box-sizing: content-box;
  ${isTopSafeArea && safeArea('top')};
  ${isBottomSafeArea && safeArea('bottom', 'padding', Spacing.medium)};
`;

const Push = (
  { top = false, bottom = false, size }: Props,
  ref: Ref<HTMLDivElement>
) => {
  return <div ref={ref} css={pushCSS(top, bottom)} style={{ height: size }} />;
};

export default forwardRef(Push);

export const enum PushSize {
  safe = 0,
  header = 44,
  bottomButton = 64,
  bottomTab = 56,
  commentForm = 70,
  tab = 43,
  floatingButton = 72,
}
